<template>
  <div v-if="visible" class="outer" @click="exit">
    <div class="top"></div>
    <div class="inner">
      <img :src="image" autofocus/>
    </div>
    <div class="bottom">
      <span class="help-text">
        Aby wyjść, kliknij w dowolne miejsce na ekranie lub klawisz ESC
      </span>
      <input
          ref="outer"
          style="
          widht: 1px;
          height: 1px;
          opacity: 0.00001;
          position: fixed;
          bottom: -50px;
        "
          type="text"
          @keydown.esc="exit"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    image: String,
  },
  data() {
    return {
      visible: false,
    };
  },
  methods: {
    show() {
      this.visible = true;
      this.$nextTick(() => {
        this.$refs.outer.focus();
      });
    },
    exit() {
      this.visible = false;
    },
  },
};
</script>

<style scoped>
.outer {
  z-index: 900;
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(2px);
  cursor: zoom-out;
}

.inner {
  text-align: center;
  background-color: rgba(255, 255, 255, 0.2);
}

.inner img {
  max-width: 95vw;
  max-height: 95vh;
  box-shadow: 0px 5px 30px rgba(0, 0, 0, 0.3);
  user-select: none;
}

.top {
  align-self: flex-start;
}

.bottom {
  align-self: flex-end;
}

.help-text {
  position: fixed;
  bottom: 1em;
  left: 0px;
  right: 0px;
  color: #fff;
  text-shadow: 0px 1px 4px rgba(0, 0, 0, 1);
  text-align: center;
  font-size: 0.9em;
  font-style: italic;
  opacity: 0.75;
}
</style>